// プレビュー(PRごと)は /pr-<番号>/ 配下で動くため、ルーターの basepath をビルドの base に合わせる。
// 末尾スラッシュは除去し、本番は "/" → "" になる。
export const ROUTER_BASEPATH: string = import.meta.env.BASE_URL.replace(
  /\/$/,
  "",
);
